/* Script cuando carga Globo Collection */
function $GloboLoad(mutationsList, $observerGlobo) {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      if ($(mutation.target).is('.template--collection #gf-tree .gf-filter-contents')) {
        $('[data-filter-type="product:metafield:custom:print"] ul.gf-option-box > li > button').each(function() {
          var $imagen = $(this).find('span.gf-option-value').text();
          $(this).find('span.gf-option-value').replaceWith('<span class="gf-option-value"><img src="' + $imagen + '"></span>');
          // console.log($imagen);
        });


        $('#gf-grid .globo-selected-items-wrapper .globo-selected-items .gf-option-label').each(function() {
          var $filter = $(this).find('.selected-item .hidden-xs').text();
          var $selector = $(this).find('.selected-item .hidden-xs').siblings('strong');
          var $print = $($selector).find('.gf-label').text();
          if($filter == 'Print'){
            $($selector).css('background-image','url("' + $print +'")');
            $(this).addClass('gf-option-label--print');
          };
        });


        
      };
    };
  };
};

const $observerGlobo = new MutationObserver($GloboLoad);
const $configGlobo = { childList: true, subtree: true };
$observerGlobo.observe(document.body, $configGlobo);